import React from 'react';

// Types
import { ElementSize } from '../../types/element-size';

// Components
import IconUser from '../Icons/IconUser/IconUser';

type UserAvatarProps = {
  userFirstName?: string;
  userLastName?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  size?: ElementSize;
  className?: string;
};

const UserAvatar: React.FC<UserAvatarProps> = ({ userFirstName, userLastName, onClick, size, className = 'bg-[#D9D9D9]' }) => {

  const SIZE_MEASUREMENT = {
    XS: { text: 'text-xs', avatar: 'w-5.5 h-5.5' },
    SM: { text: 'text-base', avatar: 'w-8.5 h-8.5' },
    MD: { text: 'text-2xl', avatar: 'w-11 h-11' },
    XXL: { text: 'text-5xl', avatar: 'w-36 h-36' }
  };

  const getMeasurementBySize = (size: ElementSize) => {
    switch (size) {
    case ElementSize.XS:
      return SIZE_MEASUREMENT[size];
    case ElementSize.SM:
      return SIZE_MEASUREMENT[size];
    case ElementSize.MD:
      return SIZE_MEASUREMENT[size];
    case ElementSize.XXL:
      return SIZE_MEASUREMENT[size];
    default:
      return SIZE_MEASUREMENT[ElementSize.MD];
    }
  };

  const userInitials =
    userFirstName &&
      userLastName &&
      typeof userFirstName === 'string' &&
      typeof userLastName === 'string'
      ? `${userFirstName[0].toUpperCase()}${userLastName[0].toUpperCase()}`
      : '';
  const classClickable = onClick ? 'cursor-pointer' : '';

  const classUserAvatarSize = getMeasurementBySize(size);
  const classUserAvatar = `
    relative font-bold text-white flex justify-center items-center rounded-full overflow-hidden after:content-[''] after:block after:absolute after:w-full after:h-full after:rounded-full after:shadow-[inset_0_0_2px_rgba(0,0,0,0.3),_inset_0_0_0_2px_rgba(0,0,0,0.3)] after:top-0 after:left-0
    ${classUserAvatarSize.avatar}
    ${classClickable}
    ${className}
  `;

  const handleClick = (event) => {
    if (typeof onClick === 'function') {
      return onClick(event);
    }
    return null;
  };

  const getAvatar = () => {
    if (userInitials !== '') {
      return <span className={`${classUserAvatarSize.text}`}>{userInitials}</span>;
    }

    return <IconUser iconClassName="flex" />;
  };

  return (
    <div
      onClick={handleClick}
      className={classUserAvatar}
    >
      {getAvatar()}
    </div>
  );
};

export default UserAvatar;
